import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';

const PrivacidadPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-zinc-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Política de Privacidad</h1>
        <p className="text-sm text-zinc-500 mb-8">Última actualización: 19 de febrero de 2026</p>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          
          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2.1. Responsable del Tratamiento
            </h2>
            <ul className="list-none space-y-2 mt-4 bg-zinc-900/50 p-4 rounded-lg">
              <li><strong className="text-zinc-200">Responsable:</strong> la empresa GUARDIÁNSFIT</li>
              <li><strong className="text-zinc-200">NIF:</strong> 45300927N</li>
              <li><strong className="text-zinc-200">Domicilio:</strong> Avenida de España 3, 51001 Ceuta (España)</li>
              <li><strong className="text-zinc-200">Email de contacto:</strong> jagubon@icloud.com</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2.2. Datos Personales Tratados
            </h2>
            <p>En GUARDIÁNSFIT se tratan las siguientes categorías de datos:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong className="text-zinc-200">Datos identificativos:</strong> nombre, correo electrónico, nombre de usuario, edad aproximada, sexo (opcional).</li>
              <li><strong className="text-zinc-200">Datos físicos:</strong> peso, altura, porcentaje de composición corporal, rendimiento deportivo, frecuencia cardiaca (no clínica), hábitos de sueño y de actividad.</li>
              <li><strong className="text-zinc-200">Datos conductuales:</strong> adherencia a los planes, cumplimiento de tareas, hábitos diarios relacionados con actividad física, evaluaciones personales, notas del entrenador.</li>
              <li><strong className="text-zinc-200">Datos técnicos:</strong> dirección IP, tipo de dispositivo, cookies, registros de uso y datos de analítica.</li>
            </ul>
            <div className="mt-4 p-4 bg-primary/10 border border-primary/20 rounded-lg">
              <p className="text-primary text-sm">
                <strong>Nota importante:</strong> No se recogen ni tratan datos médicos clínicos, diagnósticos médicos ni datos biométricos sanitarios certificados.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2.3. Finalidades del Tratamiento
            </h2>
            <p>Los datos personales se utilizan para las siguientes finalidades:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Prestación del servicio contratado y seguimiento del progreso del usuario.</li>
              <li>Personalización del entrenamiento y de los hábitos en función de los datos registrados.</li>
              <li>Facturación y gestión de suscripciones de pago.</li>
              <li>Seguridad de la plataforma y prevención de fraudes o usos indebidos.</li>
              <li>Mejora del sistema mediante estadísticas y análisis anonimizados.</li>
              <li>Envío de comunicaciones comerciales relacionadas con GUARDIÁNSFIT, en caso de contar con el consentimiento del usuario.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2.4. Base Legal del Tratamiento
            </h2>
            <p>Las bases jurídicas que legitiman el tratamiento de los datos son:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Ejecución del contrato de prestación de servicios de GUARDIÁNSFIT.</li>
              <li>Cumplimiento de obligaciones legales en materia fiscal y contable.</li>
              <li>Interés legítimo del responsable en garantizar la seguridad de la plataforma y mejorar el servicio.</li>
              <li>Consentimiento del usuario para el envío de comunicaciones comerciales y para determinadas funcionalidades opcionales.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2.5. Destinatarios de los Datos
            </h2>
            <p>Los datos personales podrán ser comunicados a:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong className="text-zinc-200">Entrenadores asignados al usuario,</strong> que accederán a los datos necesarios para la prestación del servicio.</li>
              <li><strong className="text-zinc-200">Centros deportivos</strong> que utilicen GUARDIÁNSFIT como herramienta de gestión, que solo tendrán acceso a datos estadísticos globales anonimizados, salvo acuerdo específico distinto.</li>
              <li><strong className="text-zinc-200">Proveedores de servicios tecnológicos</strong> que actúan como encargados del tratamiento (hosting, mantenimiento, analítica, comunicaciones), con los que se formalizarán los contratos exigidos por el RGPD.</li>
              <li><strong className="text-zinc-200">Proveedores de servicios de pago,</strong> que actúan como responsables del tratamiento de los datos económicos según sus propias condiciones.</li>
            </ul>
            <div className="mt-4 p-4 bg-green-900/20 border border-green-800/30 rounded-lg">
              <p className="text-green-400 text-sm font-semibold">
                No se venden datos a terceros.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2.6. Derechos de las Personas Usuarias (ARCO-PLO)
            </h2>
            <p>El usuario puede ejercer los siguientes derechos:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li><strong className="text-zinc-200">Derecho de acceso</strong> a sus datos personales.</li>
              <li><strong className="text-zinc-200">Derecho de rectificación</strong> de datos inexactos o incompletos.</li>
              <li><strong className="text-zinc-200">Derecho de supresión</strong> (derecho al olvido) cuando proceda.</li>
              <li><strong className="text-zinc-200">Derecho de limitación</strong> del tratamiento en determinados supuestos.</li>
              <li><strong className="text-zinc-200">Derecho de portabilidad</strong> de los datos en un formato estructurado, de uso común y lectura mecánica.</li>
              <li><strong className="text-zinc-200">Derecho de oposición</strong> al tratamiento, especialmente para fines de marketing.</li>
            </ul>
            <div className="mt-4 p-4 bg-zinc-900/50 rounded-lg">
              <p className="text-sm">
                Para ejercer estos derechos, el usuario puede enviar un correo electrónico a: <strong className="text-primary">jagubon@icloud.com</strong> indicando en el asunto: "Derechos GUARDIÁNSFIT" y acompañando, en su caso, copia de un documento acreditativo de su identidad.
              </p>
              <p className="text-sm mt-2 text-zinc-500">
                Asimismo, el usuario tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si considera vulnerados sus derechos.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2.7. Plazos de Conservación
            </h2>
            <p>Los datos personales se conservarán:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Mientras exista una relación contractual y de uso activo de la plataforma.</li>
              <li>Posteriormente, bloqueados, durante los plazos necesarios para cumplir las obligaciones legales (por ejemplo, 5 años en materia fiscal y contable).</li>
              <li>Determinados datos podrán conservarse de forma anonimizada indefinidamente con fines estadísticos y de mejora del sistema, sin posibilidad de identificación del usuario.</li>
            </ul>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <p className="text-sm text-zinc-500 text-center">
            © 2026 GUARDIÁNSFIT - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacidadPage;
